var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V12",
    stroke: "#495057",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3748 2.62498C18.7727 2.22716 19.3122 2.00366 19.8748 2.00366C20.4375 2.00366 20.977 2.22716 21.3748 2.62498C21.7727 3.02281 21.9962 3.56237 21.9962 4.12498C21.9962 4.68759 21.7727 5.22716 21.3748 5.62498L12.3619 14.639C12.1244 14.8762 11.8311 15.0499 11.5088 15.144L8.63585 15.984C8.5498 16.0091 8.45859 16.0106 8.37176 15.9883C8.28493 15.9661 8.20568 15.9209 8.1423 15.8575C8.07892 15.7942 8.03374 15.7149 8.01149 15.6281C7.98925 15.5412 7.99075 15.45 8.01585 15.364L8.85585 12.491C8.95038 12.169 9.12438 11.876 9.36185 11.639L18.3748 2.62498Z",
    stroke: "#495057",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6146e715a3b9c8d595ce58af186896bb.svg";
export { ForwardRef as ReactComponent };